import React from 'react';
import styles from './NumberInput.module.scss';

interface NumberInputProps {
  label: string;
  value: number | null;
  onChange: (value: number | null) => void;
  placeholder?: string;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
}

const NumberInput: React.FC<NumberInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  disabled,
  min,
  max,
  step,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = event.target.valueAsNumber;
    if (isNaN(numericValue)) {
      onChange(null);
    } else {
      onChange(numericValue);
    }
  };

  return (
    <div className={styles.container}>
      <label>{label}</label>
      <input
        type="number"
        value={value ?? ''}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        className={styles.input}
      />
    </div>
  );
};

export default NumberInput;
